require('./_polyfils.js');

if (module.hot) {
  module.hot.accept();
}

import '../styles/index.scss';

import PhotoGalleryApiV2 from './api/PhotoGalleryApiV2.js';

import Site from './site/index.js';

import GallerySidebar from './site/gallery-views/GallerySidebar';
import DetailsPage from './site/gallery-views/DetailsPage';
import CategoryPage from './site/gallery-views/CategoryPage';
import LandingPage from './site/gallery-views/LandingPage';
import GalleryTopBar from './site/gallery-views/GalleryTopBar';

import GalleryLogin from './site/account-views/login.js';
import GalleryManage from './site/account-views/manage.js';
import GalleryLogout from './site/account-views/logout.js';
import GalleryFavorites from './site/account-views/favorites.js';
import GalleryResetPassword from './site/account-views/reset-password.js';
import GalleryForgotPassword from './site/account-views/forgot-password.js';


window.addEventListener('DOMContentLoaded', function(){
  var baseUrl = window.eiiGallery.baseUrl;
  var galleryBasic = window.eiiGallery.isBasic !== undefined ? window.eiiGallery.isBasic : true;

  var galleryApi = new PhotoGalleryApiV2({
    url: window.eiiGallery.api,
    isBasic: galleryBasic,
  });

  var universalConfig = {
    api: galleryApi,
    mountId: 'content-mount',
    casesPerPage: 12,
    baseUrl: baseUrl,
    isBasic: galleryBasic
  };

  var sidebarConfig = Object.assign({}, universalConfig, {
    mountId: 'sidebar-mount',
  });
  var topbarConfig = Object.assign({}, universalConfig, {
    mountId: 'topbar-mount',
  });


  var Sidebar = new GallerySidebar(sidebarConfig);
  var TopBar = new GalleryTopBar(topbarConfig);

  var Landing = new LandingPage(universalConfig);
  var Category = new CategoryPage(universalConfig);
  var Details = new DetailsPage(universalConfig);

  var Login = new GalleryLogin(universalConfig);
  var Manage = new GalleryManage(universalConfig);
  var Logout = new GalleryLogout(universalConfig);
  var Favorites = new GalleryFavorites(universalConfig);
  var ResetPassword = new GalleryResetPassword(universalConfig);
  var ForgotPassword = new GalleryForgotPassword(universalConfig);

  var siteConfig = {
    useAdultNag: true,
    mount: universalConfig.mountId,
    baseUrl: baseUrl,
    api: galleryApi,
    isBasic: galleryBasic,
    galleryTitle: window.eiiGallery.galleryTitle,
    practice: window.eiiGallery.practice,
    onLoad: function(state, site) {
      Sidebar.updateState({ gallery: site, category: Category });
      Sidebar.setGalleryBackLink(state.baseUrl);
      Sidebar.enterScreen();
      Favorites.updateState({ gallery: site, });
      Category.updateState({ gallery: site });
      site.addLinkEventListeners();
    },
    onRouteChange: function (oldState, newState, completed, site) {
        // console.log("=====================", '\n', oldState, newState, "=====================");
        const that = this;

        function updateSection(newSectionName) {
          $('#photo-gallery').attr('data-section', newSectionName || '');
        }

        function pagesLeaveScreen() {
          Category.leaveScreen();
          Details.leaveScreen();
          Landing.leaveScreen();
          Login.leaveScreen();
          Manage.leaveScreen();
          Logout.leaveScreen();
          Favorites.leaveScreen();
          ResetPassword.leaveScreen();
          ForgotPassword.leaveScreen();
        }

        function ripApartUrl(nextPath) {
          let exploded = nextPath.split('/');

          if (exploded[0] === '') {
            exploded.shift();
          }

          pagesLeaveScreen();
          switch(exploded.filter(path => path.trim() !== '').length) {
            case 0:
            case 1:
            case 2:
              // make sure sidebar is displaying all categories
              // console.log('is landing page');

              if (that.isBasic) {
                Sidebar.enterScreen();
                TopBar.leaveScreen();
              } else {
                TopBar.enterScreen();
              }

              Sidebar.isLandingPage();
              Landing.enterScreen();
      
              updateSection('landing');

              Landing.loadSection(newState, site);

              $('#photo-gallery__title').html(that.galleryTitle);
              $('#photo-gallery__subtitle').html('');
              
              $(window).trigger('clear-filters');
              Sidebar.updateState({
                addedFilters: false,
              });
              break;

            case 2:
              // console.log(nextPath, 'should never get here since subcategories have unused parent... if so, use case 1?');
              break;

            case 3:
              // on category page this switch:
              // - alerts the sidebar to update to category section
              // - Updates gallery section
              // - tells the category component that it needs to load and it will handle it's own network request. 

              // console.log('is category page');
              // Category.enterScreen();

              newState.id = undefined;

              site.update({
                currentCategoryCanonical: newState.path,
              });

              if (that.isBasic) {
                Sidebar.leaveScreen();
              } else {
                Sidebar.isCategoryPage(newState, site);
              }
              
              updateSection('category');

              Category.loadSection(newState, site);
              Category.enterScreen();
              TopBar.enterScreen();
              $('#photo-gallery__subtitle').html(site.state.galleryTitle);

              break;

            case 4:
              updateSection('details');

              let brokenPath = nextPath.split('/').filter(path => path.trim() !== '');
              let caseId = brokenPath[brokenPath.length - 1];
              
              Details.enterScreen();
              TopBar.enterScreen();
              Sidebar.leaveScreen();

              galleryApi.getCaseById(caseId, (res) => {
                let detailsConfig = {
                  case: res,
                  api: galleryApi,
                  apiUrl: galleryApi.state.url,
                  gallery: site
                };

                Details.loadSection(detailsConfig);
              });

              break;

            default:
              //console.log(nextPath, exploded);
              break;
          }
        }


        function handleAccountUrl(url) {
          let urlToCheck = url;

          if (urlToCheck.indexOf('?') !== -1) {
            // remove the url query
            urlToCheck = urlToCheck.split('?')[0];
          }

          if (urlToCheck[url.length - 1] === "/") {
            urlToCheck = urlToCheck.slice(0, -1);
          }

          updateSection('account');
          pagesLeaveScreen();
          Sidebar.isAccountSection();

          switch(urlToCheck) {
            case `${ that.baseUrl }/my-account/login`: 
            case `${ that.baseUrl }/my-account/create`: 
              Login.enterScreen();

              break;
            case `${ that.baseUrl }/my-account/logout`: 
              galleryApi.updateUserCookie('logout');
              Logout.enterScreen();
              break;
            case `${ that.baseUrl }/my-account/favorites`: 
              Favorites.enterScreen();

              break;
            case `${ that.baseUrl }/my-account/forgot-password`:
              ForgotPassword.enterScreen();
              break;
            case `${ that.baseUrl }/my-account/reset-password`:
              ResetPassword.enterScreen();
              break;
            case `${ that.baseUrl }/my-account`:
              Manage.enterScreen();
              break;
            default: 
            
              break;
          }
        }


        if (!this.isBasic && newState.path.indexOf('/my-account') !== -1) {
          handleAccountUrl(newState.path);
        } else {
          ripApartUrl(newState.path);
        }

        completed();
      }

    };


  var mySite = new Site(siteConfig);
});


// WEBPACK FOOTER //
// ./src/scripts/index.js